// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as PictureInPictureComponent} from './PictureInPicture.svg';

import Icon, { TIconProps } from '../Icon';

export const IconPictureInPicture = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <PictureInPictureComponent/>
  </Icon>
));
